"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _index = require("../base/layer/index.js");

var _utils = require("../base/popover/utils");

var _index2 = require("../index");

var _Box = _interopRequireDefault(require("../Box"));

var _uniqueId = _interopRequireDefault(require("../uniqueId"));

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var __jsx = _react["default"].createElement;

var mountNode = function mountNode() {
  if (typeof document !== "undefined") {
    return document.getElementById("__layers__");
  }
};

var scrollbarWidth;

function getScrollbarWidth() {
  if (typeof scrollbarWidth === "number") {
    return scrollbarWidth;
  } // Creating invisible container


  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100%"; // outer.style.overflow = "scroll"; // forcing scrollbar to appear
  // outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

  document.body.appendChild(outer); // Creating inner element and placing it in the container

  var inner = document.createElement("div");
  outer.appendChild(inner); // Calculating difference between container's full width and the child width

  scrollbarWidth = window.innerWidth - outer.clientWidth; // Removing temporary elements from the DOM

  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}

var centered = function centered(_ref) {
  var width = _ref.width,
      height = _ref.height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      animationTime = _ref.animationTime,
      animationEase = _ref.animationEase,
      backgroundColor = _ref.backgroundColor,
      shouldShow = _ref.shouldShow;
  return {
    anchored: false,
    background: {
      backgroundColor: backgroundColor,
      transition: "opacity ".concat(animationTime, "s ").concat(animationEase),
      opacity: shouldShow ? 1 : 0
    },
    contentWrapper: {
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    },
    content: {
      transition: "all ".concat(animationTime, "s ").concat(animationEase),
      opacity: shouldShow ? 1 : 0
    }
  };
};

var slide = function slide(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      minWidth = _ref2.minWidth,
      minHeight = _ref2.minHeight,
      maxWidth = _ref2.maxWidth,
      maxHeight = _ref2.maxHeight,
      animationTime = _ref2.animationTime,
      animationEase = _ref2.animationEase,
      backgroundColor = _ref2.backgroundColor,
      axis = _ref2.axis,
      fromStart = _ref2.fromStart,
      shouldShow = _ref2.shouldShow;
  return {
    anchored: false,
    background: {
      backgroundColor: backgroundColor,
      transition: "opacity ".concat(animationTime, "s ").concat(animationEase),
      opacity: shouldShow ? 1 : 0
    },
    contentWrapper: {
      position: "absolute",
      top: axis === "Y" && fromStart || axis === "X" ? 0 : "auto",
      bottom: axis === "Y" && !fromStart ? 0 : "auto",
      left: axis === "X" && fromStart || axis === "Y" ? 0 : "auto",
      right: axis === "X" && !fromStart ? 0 : "auto",
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    },
    content: {
      transition: "all ".concat(animationTime, "s ").concat(animationEase),
      transform: shouldShow ? "none" : "translate".concat(axis, "(").concat(fromStart ? "-" : "", "100%)"),
      opacity: shouldShow ? 1 : 0
    }
  };
};

var popoverRootDefault = function popoverRootDefault(_ref3) {
  var children = _ref3.children,
      isOpen = _ref3.isOpen,
      isVisible = _ref3.isVisible,
      popoverOffset = _ref3.popoverOffset,
      showArrow = _ref3.showArrow,
      placement = _ref3.placement,
      width = _ref3.width,
      height = _ref3.height,
      minWidth = _ref3.minWidth,
      minHeight = _ref3.minHeight,
      maxWidth = _ref3.maxWidth,
      maxHeight = _ref3.maxHeight;
  return (0, _objectSpread2["default"])({
    boxSizing: "border-box",
    position: "absolute",
    top: 0,
    left: 0,
    transition: isVisible ? "all .1s ease-out" : "none",
    opacity: isVisible && isOpen ? 1 : 0,
    transform: isVisible && isOpen ? (0, _utils.getEndPosition)(popoverOffset) : (0, _utils.getStartPosition)(popoverOffset, placement, showArrow)
  }, (0, _utils.getPopoverMarginStyles)(showArrow, placement), {
    width: width,
    height: height,
    minWidth: minWidth,
    minHeight: minHeight,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    overflowY: "auto",
    __children: children
  });
};

function layerAdded(isAnchoredToWindow) {
  window.__cui_layerCounter = window.__cui_layerCounter || {
    window: 0,
    element: 0,
    all: 0
  };

  if (isAnchoredToWindow) {
    if (window.__cui_layerCounter.window === 0 && window.__cui_notificationSystemSetLayerOpen) {
      window.__cui_notificationSystemSetLayerOpen(true);
    }

    window.__cui_layerCounter.window++;
  } else {
    window.__cui_layerCounter.element++;
  }

  window.__cui_layerCounter.all = window.__cui_layerCounter.window + window.__cui_layerCounter.element;
}

function layerRemoved(isAnchoredToWindow) {
  window.__cui_layerCounter = window.__cui_layerCounter || {
    window: 0,
    element: 0,
    all: 0
  };

  if (isAnchoredToWindow) {
    window.__cui_layerCounter.window = Math.max(0, window.__cui_layerCounter.window - 1);

    if (window.__cui_layerCounter.window === 0 && window.__cui_notificationSystemSetLayerOpen) {
      window.__cui_notificationSystemSetLayerOpen(false);
    }
  } else {
    window.__cui_layerCounter.element = Math.max(0, window.__cui_layerCounter.element - 1);
  }

  window.__cui_layerCounter.all = window.__cui_layerCounter.window + window.__cui_layerCounter.element;
}

function layerChanged(isAnchoredToWindow) {
  window.__cui_layerCounter = window.__cui_layerCounter || {
    window: 0,
    element: 0,
    all: 0
  };

  if (isAnchoredToWindow) {
    if (window.__cui_layerCounter.window === 0 && window.__cui_notificationSystemSetLayerOpen) {
      window.__cui_notificationSystemSetLayerOpen(true);
    }

    window.__cui_layerCounter.window++;
    window.__cui_layerCounter.element = Math.max(0, window.__cui_layerCounter.element - 1);
  } else {
    window.__cui_layerCounter.element++;
    window.__cui_layerCounter.window = Math.max(0, window.__cui_layerCounter.window - 1);

    if (window.__cui_layerCounter.window === 0 && window.__cui_notificationSystemSetLayerOpen) {
      window.__cui_notificationSystemSetLayerOpen(false);
    }
  }

  window.__cui_layerCounter.all = window.__cui_layerCounter.window + window.__cui_layerCounter.element;
}

function Layer$(props) {
  var _useState = (0, _react.useState)(false),
      isMounted = _useState[0],
      setMounted = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isVisible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      isLayerMounted = _useState3[0],
      setLayerMounted = _useState3[1];

  var onClose = props.onClose,
      isOpen = props.isOpen,
      anchoredTo = props.anchoredTo,
      _props$sx = props.sx,
      sx = _props$sx === void 0 ? {} : _props$sx;

  var _Object$assign = (0, _assign["default"])((0, _objectSpread2["default"])({}, sx), props),
      width = _Object$assign.width,
      height = _Object$assign.height,
      minWidth = _Object$assign.minWidth,
      minHeight = _Object$assign.minHeight,
      maxWidth = _Object$assign.maxWidth,
      maxHeight = _Object$assign.maxHeight,
      animationTime = _Object$assign.animationTime,
      animationEase = _Object$assign.animationEase,
      backgroundColor = _Object$assign.backgroundColor,
      _Object$assign$root = _Object$assign.root,
      root = _Object$assign$root === void 0 ? {} : _Object$assign$root,
      _Object$assign$contai = _Object$assign.container,
      container = _Object$assign$contai === void 0 ? {} : _Object$assign$contai,
      placement = _Object$assign.placement; // backward compatibility. Now props are recommended.


  var closeTimeout = 0;
  var animateStartTimer = (0, _react.useRef)(null);
  var animateOutTimer = (0, _react.useRef)(null); // Popover

  var popperRef = (0, _react.useRef)(null);
  var arrowRef = (0, _react.useRef)(null);

  var _useState4 = (0, _react.useState)({
    left: 0,
    top: 0
  }),
      arrowOffset = _useState4[0],
      setArrowOffset = _useState4[1];

  var _useState5 = (0, _react.useState)("bottomLeft"),
      popoverPlacement = _useState5[0],
      setPopoverPlacement = _useState5[1];

  var _useState6 = (0, _react.useState)({
    left: 0,
    top: 0
  }),
      popoverOffset = _useState6[0],
      setPopoverOffset = _useState6[1]; // ID (to count number of open layers)


  var id = (0, _react.useRef)((0, _uniqueId["default"])());

  var clearTimers = function clearTimers() {
    clearTimeout(animateOutTimer.current);
    cancelAnimationFrame(animateStartTimer.current);
  };

  var show = function show() {
    clearTimers();
    animateStartTimer.current = requestAnimationFrame(function () {
      setVisible(true);
    });
  };

  var hide = function hide() {
    animateOutTimer.current = setTimeout(function () {
      setVisible(false);
    }, 500);
  };

  var shouldShow = isVisible && isOpen;
  anchoredTo = (0, _index2.responsiveValueCurrent)(anchoredTo) || "window";
  var isAnchored = anchoredTo && anchoredTo !== "window";
  var currentPlacement = (0, _index2.responsiveValueCurrent)(placement);
  var current = {
    isAnchored: isAnchored,
    anchoredTo: anchoredTo,
    placement: currentPlacement,
    width: typeof width === "function" ? width({
      anchorRect: anchoredTo.current && anchoredTo.current.getBoundingClientRect() || {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        right: 0,
        left: 0,
        top: 0,
        bottom: 0
      }
    }) : width || "auto",
    height: typeof height === "function" ? height({
      anchorRect: anchoredTo.current && anchoredTo.current.getBoundingClientRect() || {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        right: 0,
        left: 0,
        top: 0,
        bottom: 0
      }
    }) : height || "auto",
    minWidth: minWidth || 0,
    minHeight: minHeight || 0,
    maxWidth: maxWidth || "10000px",
    maxHeight: maxHeight || "10000px",
    animationTime: animationTime || 0.3,
    animationEase: animationEase || "cubic-bezier(0.19, 1, 0.22, 1)",
    backgroundColor: backgroundColor || "rgba(0,0,0,0.3)",
    shouldShow: shouldShow
  }; // Following 2 useEffects are responsible for counting open non-anchored layers

  (0, _react.useEffect)(function () {
    var body = document.querySelector("body");
    var scrollbarWidth = getScrollbarWidth();

    if (isOpen === true) {
      layerAdded(!current.isAnchored);
    } else {
      layerRemoved(!current.isAnchored);
    }

    if (isOpen && window.__cui_layerCounter.all === 1) {
      body.style["padding-right"] = scrollbarWidth + "px";
      body.style["overflow-y"] = "hidden";
    } else if (!isOpen && window.__cui_layerCounter.all == 0) {
      body.style.removeProperty("overflow-y");
      body.style.removeProperty("padding-right");
    }
  }, [isOpen]); // on route change!

  (0, _react.useEffect)(function () {
    var onRouteChange = function onRouteChange() {
      if (onClose) {
        onClose();
      }
    };

    if (!window.__cui_onRouteChange) {
      window.__cui_onRouteChange = [];
    }

    window.__cui_onRouteChange.push(onRouteChange);

    return function () {
      window.__cui_onRouteChange = window.__cui_onRouteChange.filter(function (x) {
        return x !== onRouteChange;
      });
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!isOpen) {
      return;
    }

    layerChanged(!current.isAnchored);
  }, [current.isAnchored]);
  (0, _react.useEffect)(function () {
    if (isOpen) {
      if (!current.isAnchored) {
        show();
      }
    } else {
      hide();
    }
  }, [isOpen]);
  useOnClickOutside([popperRef.current, arrowRef.current, anchoredTo.current], function () {
    if (!isOpen) {
      return;
    }

    if (current.isAnchored) {
      if (onClose) {
        onClose();
      }
    }
  });
  (0, _react.useEffect)(function () {
    setMounted(true);
  });

  if (!isMounted) {
    return null;
  }

  if (!current.isAnchored) {
    if (!isOpen && !isVisible) {
      return null;
    }

    var styles;

    switch (currentPlacement) {
      case "left":
        styles = slide((0, _objectSpread2["default"])({}, current, {
          height: "100%",
          axis: "X",
          fromStart: true
        }));
        break;

      case "right":
        styles = slide((0, _objectSpread2["default"])({}, current, {
          height: "100%",
          axis: "X",
          fromStart: false
        }));
        break;

      case "top":
        styles = slide((0, _objectSpread2["default"])({}, current, {
          width: "100%",
          axis: "Y",
          fromStart: true
        }));
        break;

      case "bottom":
        styles = slide((0, _objectSpread2["default"])({}, current, {
          width: "100%",
          axis: "Y",
          fromStart: false
        }));
        break;

      default:
        // "center"
        styles = centered(current);
    }

    return (0, _index2.jsx)(_index.Layer, {
      mountNode: mountNode()
    }, (0, _index2.jsx)(_Box["default"], {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      className: "__layer-window__"
    }, (0, _index2.jsx)(_Box["default"], {
      sx: (0, _objectSpread2["default"])({
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        bg: "rgba(0,0,0,0.5)",
        zIndex: "-1"
      }, styles.background),
      onClick: onClose
    }), (0, _index2.jsx)(_Box["default"], {
      sx: (0, _objectSpread2["default"])({}, styles.contentWrapper)
    }, (0, _index2.jsx)(_Box["default"], {
      sx: (0, _objectSpread2["default"])({
        position: "relative",
        width: "100%",
        height: "100%",
        minHeight: "inherit",
        minWidth: "inherit",
        maxHeight: "inherit",
        maxWidth: "inherit",
        overflowY: "auto"
      }, styles.content, root)
    }, typeof props.children === "function" ? props.children({
      anchored: current.isAnchored,
      close: function close() {
        if (onClose) {
          onClose();
        }
      }
    }) : props.children))));
  }

  if (!isOpen) {
    return null;
  }

  var onPopperUpdate = function onPopperUpdate(normalizedOffsets, data) {
    var placement = (0, _utils.fromPopperPlacement)(data.placement) || "top"; // this.setState({
    //     arrowOffset: normalizedOffsets.arrow,
    //     popoverOffset: normalizedOffsets.popper,
    //     placement
    // });

    setPopoverOffset(normalizedOffsets.popper);
    setPopoverPlacement(placement);
    setArrowOffset(normalizedOffsets.arrowOffset); // Now that element has been positioned, we can animate it in
    // this.animateInTimer = setTimeout(this.animateIn, ANIMATE_IN_TIME);

    show();
    return data;
  };

  var getSharedProps = function getSharedProps() {
    return {
      showArrow: false,
      arrowOffset: arrowOffset,
      popoverOffset: popoverOffset,
      placement: popoverPlacement,
      isVisible: isVisible,
      isOpen: isOpen,
      anchorWidth: anchoredTo.current && anchoredTo.current.clientWidth
    };
  };

  var renderPopover = function renderPopover() {
    // UPDATED CODE:
    var state = (0, _objectSpread2["default"])({}, getSharedProps(), {
      anchored: !!current.isAnchored,
      close: function close() {
        if (onClose) {
          onClose();
        }
      }
    }); // const children = <Box sx={{...container}}>{
    //     typeof props.children === "function"
    //         ? props.children(state)
    //         : props.children
    // }</Box>;

    var children = typeof props.children === "function" ? props.children(state) : props.children; // const bodyProps = this.getPopoverBodyProps();

    var popoverRootSpec = (0, _index2.getElementSpec)(root, popoverRootDefault, (0, _objectSpread2["default"])({}, state, {
      width: current.width,
      height: current.height,
      minWidth: current.minWidth,
      maxWidth: current.maxWidth,
      minHeight: current.minHeight,
      maxHeight: current.maxHeight,
      children: children
    }));
    var popoverRoot = (0, _index2.createElement)(popoverRootSpec, {
      ref: popperRef // ...bodyProps

    });
    return popoverRoot;
  }; // onMount and onUnmount are necessary to create rerender. Rerender makes popperRef to become not-null and TetherBehaviour depends on that


  return (0, _index2.jsx)(_index.Layer, {
    mountNode: mountNode(),
    onMount: function onMount() {
      return setLayerMounted(true);
    },
    onUnmount: function onUnmount() {
      return setLayerMounted(false);
    }
  }, (0, _index2.jsx)(_index.TetherBehavior, {
    anchorRef: anchoredTo.current,
    arrowRef: arrowRef.current,
    popperRef: popperRef.current // Remove the `ignoreBoundary` prop in the next major version
    // and have it replaced with the TetherBehavior props overrides
    ,
    popperOptions: {
      modifiers: {
        preventOverflow: {
          enabled: !props.ignoreBoundary
        }
      }
    },
    onPopperUpdate: onPopperUpdate,
    placement: currentPlacement || "bottomLeft"
  }, renderPopover()));
}

function useOnClickOutside(nodes, callback) {
  (0, _react.useEffect)(function () {
    var onDocumentClick = function onDocumentClick(evt) {
      var target = evt.target;

      for (var i in nodes) {
        var node = nodes[i];

        if (!node) {
          continue;
        }

        if (node === target || node.contains(target)) {
          return;
        }
      }

      if (callback) {
        callback(evt);
      }
    };

    document.addEventListener("mousedown", onDocumentClick);
    return function () {
      document.removeEventListener("mousedown", onDocumentClick);
    };
  });
}

function getLayout(children, header, footer, onLinkClick) {
  var containerSx = {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "100%",
    maxWidth: "inherit",
    maxHeight: "inherit",
    minWidth: "inherit",
    minHeight: "inherit"
  };
  return (0, _index2.jsx)(_Box["default"], {
    sx: containerSx,
    onClick: function onClick(e) {
      if (e.target && e.target.tagName === "A") {
        onLinkClick();
      }
    }
  }, header && (0, _index2.jsx)(_Box["default"], {
    sx: {
      flex: "0 0 auto"
    }
  }, header), (0, _index2.jsx)(_Box["default"], {
    sx: {
      flex: "1 1 auto",
      overflow: "auto"
    }
  }, children), footer && (0, _index2.jsx)(_Box["default"], {
    sx: {
      flex: "0 0 auto"
    }
  }, footer));
} // Temporary wrapper around layer solving 2 tasks: header, footer and focus lock


function LayerWithHeaderAndFooter(props) {
  var children = props.children,
      header = props.header,
      footer = props.footer,
      container = props.container,
      _props$focusLock = props.focusLock,
      focusLock = _props$focusLock === void 0 ? false : _props$focusLock,
      _props$hideOnLinkClic = props.hideOnLinkClick,
      hideOnLinkClick = _props$hideOnLinkClic === void 0 ? false : _props$hideOnLinkClic,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["children", "header", "footer", "container", "focusLock", "hideOnLinkClick"]);

  var _useState7 = (0, _react.useState)(true),
      focusLockDisabled = _useState7[0],
      setFocusLockDisabled = _useState7[1]; // We must enabled focus lock AFTER its mounted. For popups its mounted top: 0, left: 0 in the first place and then its position changes. Focus too early and you'll cause unwanted "scroll to top" effect.


  (0, _react.useEffect)(function () {
    if (props.isOpen) {
      setTimeout(function () {
        setFocusLockDisabled(false);
      }, 0);
    } else {
      setFocusLockDisabled(true);
    }
  }, [props.isOpen]);

  var content = function content(params) {
    return getLayout((0, _index2.jsx)(_Box["default"], {
      sx: container
    }, typeof children === "function" ? children(params) : children), typeof header === "function" ? header(params) : header, typeof footer === "function" ? footer(params) : footer, function () {
      if (hideOnLinkClick) {
        params.close();
      }
    });
  };

  var output;

  if (focusLock) {
    output = function output(params) {
      return (0, _index2.jsx)(_reactFocusLock["default"], {
        returnFocus: true,
        lockProps: {
          style: {
            width: "100%",
            height: "100%",
            maxWidth: "inherit",
            maxHeight: "inherit",
            minWidth: "inherit",
            minHeight: "inherit"
          },
          role: "dialog"
        },
        disabled: focusLockDisabled
      }, content(params));
    };
  } else {
    output = function output(params) {
      return content(params);
    };
  }

  return (0, _index2.jsx)(Layer$, restProps, output);
} // Layer with Button


function Layer$$(_ref4) {
  var button = _ref4.button,
      layerProps = (0, _objectWithoutProperties2["default"])(_ref4, ["button"]);
  var _layerProps$anchoredT = layerProps.anchoredTo,
      anchoredTo = _layerProps$anchoredT === void 0 ? "button" : _layerProps$anchoredT,
      _layerProps$closeOnEs = layerProps.closeOnEsc,
      closeOnEsc = _layerProps$closeOnEs === void 0 ? true : _layerProps$closeOnEs,
      _onClose = layerProps.onClose,
      restProps = (0, _objectWithoutProperties2["default"])(layerProps, ["anchoredTo", "closeOnEsc", "onClose"]);

  var _useState8 = (0, _react.useState)(false),
      isOpen = _useState8[0],
      setOpen = _useState8[1];

  var buttonRef = (0, _react.useRef)(null); // TODO: Make this not only array

  if ((0, _isArray["default"])(anchoredTo)) {
    anchoredTo = anchoredTo.map(function (x) {
      return x === "button" ? buttonRef : x;
    });
  } else {
    anchoredTo = anchoredTo === "button" ? buttonRef : anchoredTo;
  }

  (0, _react.useEffect)(function () {
    var onDocumentKeyPress = function onDocumentKeyPress(evt) {
      if (!closeOnEsc) {
        return;
      }

      if (evt.key !== "Escape") {
        return;
      } // Ignore events that have been `event.preventDefault()` marked.


      if (event.defaultPrevented) {
        return;
      }

      setOpen(false);

      if (_onClose) {
        _onClose({
          type: "esc"
        });
      }
    };

    document.addEventListener("keyup", onDocumentKeyPress);
    return function () {
      document.removeEventListener("keyup", onDocumentKeyPress);
    };
  });

  if (!button) {
    return (0, _index2.jsx)(LayerWithHeaderAndFooter, (0, _extends2["default"])({}, layerProps, {
      onClose: _onClose
    }));
  }

  return _react["default"].cloneElement(button, {
    onClick: function onClick() {
      setOpen(true);
    },
    buttonRef: buttonRef,
    selected: isOpen,
    __portals__: (0, _index2.jsx)(LayerWithHeaderAndFooter, (0, _extends2["default"])({}, restProps, {
      anchoredTo: anchoredTo,
      isOpen: isOpen,
      onClose: function onClose() {
        setOpen(false);

        if (_onClose) {
          _onClose();
        }
      }
    }))
  });
}

var _default = Layer$$;
exports["default"] = _default;